import React from 'react';
import './style/HundredPercentContainer.scss';

export default function HundredPercentContainer({
  children,
  id = null,
  className = '',
  style,
  flex,
  scroll,
  onScroll,
}) {
  const classes = ['HundredPercentContainer'];
  if (flex) {
    classes.push('HundredPercentContainer--Flex');
  }
  if (scroll) {
    classes.push('HundredPercentContainer--Scroll');
  }
  if (className) {
    classes.push(className);
  }

  return (
    <div
      className={classes.join(' ')}
      id={id}
      style={style}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
}
